import React from "react";
import PropTypes from "prop-types";
import { Table, Button } from "semantic-ui-react";
import _ from "lodash";
import ContactosRow from "./contactosTabla/ContactosRow";
import AddContactos from "./contactosTabla/AddContactos";
import shortid from "shortid";

class ContactosTabla extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleAddContacto: false,
      contactos: this.props.value
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ contactos: nextProps.value });
  }

  showAddContacto = () =>
    this.setState({ visibleAddContacto: !this.state.visibleAddContacto });

  handleChange = value => {
    let data = _.cloneDeep(this.state.contactos);

    let val = {};
    const key = shortid.generate();
    val[key] = value;

    this.setState({
      visibleAddContacto: !this.state.visibleAddContacto
    });

    this.props.onChange(Object.assign({}, data, val));
  };

  borraContacto = id_contacto => {
    let data = _.cloneDeep(this.state.contactos);
    _.unset(data, id_contacto);
    this.props.onChange(data);
  };

  renderFilas = () => {
    let filas = [];
    _.forOwn(this.state.contactos, (contacto, k) => {
      filas.push(
        <ContactosRow
          editable={this.props.editable}
          key={k}
          contactoID={k}
          contacto={contacto}
          borraContacto={this.borraContacto}
          handleChange={this.handleInputChange}
        />
      );
    });

    return filas;
  };

  render() {
    return (
      <div>
        <Table structured compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Nombre</Table.HeaderCell>
              <Table.HeaderCell>Cargo</Table.HeaderCell>
              <Table.HeaderCell>Correo</Table.HeaderCell>
              <Table.HeaderCell>Teléfono</Table.HeaderCell>
              {this.props.editable && <Table.HeaderCell />}
            </Table.Row>
          </Table.Header>

          <Table.Body>{this.renderFilas()}</Table.Body>

          {this.props.editable && (
            <Table.Footer fullWidth>
              <Table.Row>
                <Table.HeaderCell colSpan="5">
                  <Button
                    icon="user"
                    content="Añadir Contacto"
                    floated="right"
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.showAddContacto}
                  />
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          )}
        </Table>
        {this.state.visibleAddContacto && (
          <AddContactos
            closeDialog={this.showAddContacto}
            show={this.state.visibleAddContacto}
            onChange={this.handleChange}
          />
        )}
      </div>
    );
  }
}

ContactosTabla.defaultProps = {
  editable: false
};

ContactosTabla.propTypes = {
  contactos: PropTypes.object,
  showAddContacto: PropTypes.func,
  changeInfoContactos: PropTypes.func,
  handleBorrarContacto: PropTypes.func,
  editable: PropTypes.bool
};

export default ContactosTabla;



// WEBPACK FOOTER //
// ./src/pages/shared/colegios/colegioForm/ContactosTabla.jsx